var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 13,
    viewBox: "0 0 142 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6282 1H30L37.3718 13H40L32.6282 1Z",
    fill: "url(#paint0_linear_276_8387)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6282 1H20L27.3718 13H30L22.6282 1Z",
    fill: "url(#paint1_linear_276_8387)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6282 1H10L17.3718 13H20L12.6282 1Z",
    fill: "url(#paint2_linear_276_8387)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62821 1H0L7.37179 13H10L2.62821 1Z",
    fill: "url(#paint3_linear_276_8387)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4062 0.399925H51.5343L52.4343 1.69593V3.44193L50.3643 5.61993H50.8863L52.6143 8.15793V12.0639L51.0843 12.9999H44.4062V0.399925ZM46.0983 1.92993V5.61993H48.2222L50.7423 2.99193V1.92993H46.0983ZM46.0983 7.16793V11.4519H50.9223V8.37393L50.0582 7.16793H46.0983Z",
    fill: "url(#paint4_linear_276_8387)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8372 0.399925H61.9852L63.2812 2.34393L62.1832 3.44193L61.1752 1.94793H57.4672L56.9992 2.43393V10.5699L57.5752 11.4519H61.8412V7.05993H59.3032V5.51193H62.7412L63.5332 6.71793V12.9999H56.7652L55.3252 10.8399V1.98393L56.8372 0.399925Z",
    fill: "url(#paint5_linear_276_8387)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8942 8.37393H67.4862V6.82593H73.8942V8.37393Z",
    fill: "url(#paint6_linear_276_8387)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2872 0.273926H84.5252L85.9652 2.43393V4.28793L79.4312 11.0379V11.4519H85.9652V12.9999H77.7572V10.5699L84.6692 3.40593L83.6072 1.82193H79.9352L78.5852 3.15393L77.7212 1.87593L79.2872 0.273926Z",
    fill: "url(#paint7_linear_276_8387)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4041 0.273926H95.6421V1.82193H91.0701L90.5841 2.32593V6.62793L91.7001 5.49393H96.2541L97.1001 6.73593V10.8039L94.9581 12.9999H90.3321L88.8921 10.7139V1.83993L90.4041 0.273926ZM90.5841 10.4979L91.2501 11.4519H94.3101L95.3901 10.3359V7.05993H92.3481L90.5841 8.82393V10.4979Z",
    fill: "url(#paint8_linear_276_8387)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.575 0.273926H106.759L108.253 2.50593V11.4339L106.759 12.9999H101.575L100.045 10.7499V1.83993L101.575 0.273926ZM101.737 2.34393V8.30193L106.543 3.31593V2.77593L105.913 1.82193H102.223L101.737 2.34393ZM101.737 10.5159L102.385 11.4519H106.075L106.543 10.9479V5.38593L101.737 10.3899V10.5159Z",
    fill: "url(#paint9_linear_276_8387)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.97 0.273926H118.074L119.406 2.28993V4.75593L117.822 6.41193L119.406 8.76993V10.7679L117.282 12.9999H112.728L111.198 10.7499V8.51793L112.836 6.89793H112.656L111.198 4.75593V3.15393L113.97 0.273926ZM112.89 4.50393L113.52 5.43993H116.562L117.696 4.32393V2.54193L117.21 1.82193H114.636L112.89 3.60393V4.50393ZM112.89 10.4979L113.538 11.4519H116.562L117.696 10.3359V9.02193L116.328 6.98793H114.798L112.89 8.98593V10.4979Z",
    fill: "url(#paint10_linear_276_8387)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.305 0.273926H128.579L130.559 3.24393V10.2819L128.129 12.9999H123.071V11.4519H127.427L128.849 9.81393V7.05993H124.331L122.351 4.12593V1.26393L123.305 0.273926ZM124.043 3.85593L125.141 5.49393H128.849V3.51393L127.715 1.82193H124.043V3.85593Z",
    fill: "url(#paint11_linear_276_8387)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.458 0.273926H139.732L141.712 3.24393V10.2819L139.282 12.9999H134.224V11.4519H138.58L140.002 9.81393V7.05993H135.484L133.504 4.12593V1.26393L134.458 0.273926ZM135.196 3.85593L136.294 5.49393H140.002V3.51393L138.868 1.82193H135.196V3.85593Z",
    fill: "url(#paint12_linear_276_8387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_8387",
    x1: 35,
    y1: 1,
    x2: 35,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_276_8387",
    x1: 25,
    y1: 1,
    x2: 25,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_276_8387",
    x1: 15,
    y1: 1,
    x2: 15,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_276_8387",
    x1: 5,
    y1: 1,
    x2: 5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_276_8387",
    x1: 92.5,
    y1: -1,
    x2: 92.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222223"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.4655b1d7c48b0b5efc5b419a7dd53b59.svg";
export { ForwardRef as ReactComponent };